// English copy — Kelo Diamonds
const en = {
  code: "en",
  announcement: "Premium Moissanite Jewelry · Personalized Ordering Assistance",
  nav: {
    shop: "Shop",
    bestSellers: "Best Sellers",
    sizeGuide: "Size Guide",
    whyMoissanite: "Why Moissanite",
    ourStory: "Our Story",
    faq: "FAQ",
    cart: "Cart",
    menu: "Menu",
  },
  hero: {
    eyebrow: "KELO DIAMONDS",
    headline: "Built Under Pressure.",
    tagline: "Highest-grade VVS moissanite. Real brilliance. Smart luxury.",
    scrollCue: "DISCOVER MORE",
  },
  trust: ["925 Sterling Silver", "VVS Moissanite", "Sold as a Complete Pair", "Premium Gift Box", "Personalized Support"],
  flagship: {
    eyebrow: "Flagship",
    statement:
      "A refined pair of round-cut VVS moissanite studs set in 925 sterling silver and designed for exceptional visual brilliance.",
    chooseSize: "Size",
    soldAsPair: "Sold as a complete pair",
    quantity: "Quantity",
    unitPrice: "Unit price",
    addToCart: "Add to cart",
    added: "Added to cart",
    buy: "Order now",
    whatsapp: "WhatsApp",
    includedTitle: "What your pair includes",
    included: [
      "Two matching moissanite earrings",
      "VVS clarity · D color",
      "925 sterling silver, four-prong setting",
      "Your selected CTW size",
      "Premium gift box",
      "Product-care instructions",
      "Personalized ordering support",
    ],
    specsTitle: "Product details",
    specs: [
      ["Stone", "Moissanite"],
      ["Shape", "Round Cut"],
      ["Clarity", "VVS"],
      ["Color", "D Color"],
      ["Metal", "925 Sterling Silver"],
      ["Setting", "Four-Prong Setting"],
      ["Sold as", "One complete pair"],
      ["Packaging", "Premium Gift Box"],
    ],
    ctwTitle: "Understanding CTW",
    ctwNote: "CTW refers to the combined diamond-equivalent size of both earrings.",
  },
  collection: {
    title: "Explore the Collection",
    subtitle: "Three refined designs, each crafted in 925 sterling silver.",
    viewDetails: "View details",
    buy: "Order",
  },
  sizeGuide: {
    title: "Size Guide",
    subtitle: "Choose the presence that fits your style.",
    total: "Total (both earrings)",
    perEarring: "Per earring",
    note: "The visual guide is an approximation. Perceived size may vary depending on screen dimensions and individual anatomy.",
    help: "Need help choosing a size?",
    videoLabel: "Video · Visual guide",
    videoAria: "Play size guide video",
    styles: {
      "1ctw": "Subtle and refined.",
      "2ctw": "Balanced for everyday wear.",
      "3ctw": "Noticeably bold.",
      "4ctw": "Strong visual presence.",
    },
    styleShort: {
      "1ctw": "Subtle",
      "2ctw": "Balanced",
      "3ctw": "Bold",
      "4ctw": "Strong presence",
    },
  },
  why: {
    title: "Why Moissanite",
    subtitle: "A premium gemstone choice with its own advantages.",
    benefits: [
      ["Brilliance", "Exceptional fire and sparkle in every light."],
      ["Durability", "9.25 on the Mohs scale — built for frequent wear with proper care."],
      ["Premium appearance", "A refined, high-end look that draws attention."],
      ["Excellent value", "Remarkable presence for a fraction of the cost."],
    ],
    comparisonTitle: "An honest comparison",
    comparison: {
      headers: ["", "Natural Diamond", "Moissanite"],
      rows: [
        ["Stone type", "Carbon crystal", "Silicon carbide"],
        ["Visual brilliance", "Elegant brilliance", "More fire and sparkle"],
        ["Durability", "10 Mohs", "9.25 Mohs"],
        ["Relative price", "Thousands of dollars", "A fraction of the cost"],
        ["Care", "Standard care", "Standard care"],
      ],
      note: "Moissanite is its own gemstone with a distinct beauty. It is not a diamond, and we never present it as one.",
    },
  },
  macro: { title: "Every Detail Matters.", support: "Designed to be examined from every angle." },
  story: {
    eyebrow: "The product story",
    infoTitle: "Every pair includes",
    infoItems: [
      "VVS Clarity",
      "D Color",
      "925 Sterling Silver",
      "Premium Gift Box",
      "Lifetime Support",
    ],
    slides: [
      { headline: "Brilliance You Can See.", sub: "Made to command attention." },
      { headline: "Passes the Diamond Tester.", sub: "Tested for thermal conductivity." },
      { headline: "VVS Clarity.", sub: "Exceptional clarity in every stone." },
      { headline: "D Color.", sub: "A bright, colorless appearance." },
      { headline: "925 Sterling Silver.", sub: "Crafted for everyday wear." },
      { headline: "Premium Presentation.", sub: "Every pair arrives gift-ready." },
      { headline: "Designed to Stand Out.", sub: "Choose your perfect size.", cta: "Explore Sizes" },
    ],
    aria: {
      prev: "Previous story",
      next: "Next story",
      pause: "Pause",
      play: "Play",
    },
    share: {
      button: "Share",
      title: "Share this story",
      channels: {
        whatsapp: "WhatsApp",
        twitter: "X (Twitter)",
        facebook: "Facebook",
        copy: "Copy link",
        copied: "Copied!",
      },
      text: "Look at this — Kelo Diamonds",
    },
  },
  quality: {
    title: "Crafted with Attention to Detail",
    blocks: [
      ["VVS Moissanite", "High clarity for a clean, bright stone."],
      ["D Color", "The highest, most colorless grade."],
      ["Round Cut", "A timeless cut engineered for brilliance."],
      ["925 Sterling Silver", "Genuine sterling silver settings."],
      ["Four-Prong Setting", "Secure hold that lets light through."],
      ["Sold as a Pair", "Two matching earrings, always."],
    ],
  },
  packaging: {
    title: "Ready to Give. Designed to Keep.",
    text: "Every pair arrives in a premium gift box, ready to be gifted or kept.",
  },
  howOrder: {
    title: "How Ordering Works",
    steps: [
      ["Choose your style", "Select your preferred earring design."],
      ["Select your size", "Compare 1 CTW, 2 CTW, 3 CTW and 4 CTW."],
      ["Send your order", "Your product, size, quantity and price are prepared automatically."],
      ["Confirm with our team", "Complete availability, payment and delivery through WhatsApp."],
    ],
    note: "Your order is confirmed after availability, payment and delivery details are approved by our team.",
    cta: "Complete your order with personal assistance",
  },
  shipping: {
    title: "Shipping & Customer Support",
    text: "Delivery timing and available options are confirmed before payment. A real representative assists you before and after your order.",
    supportTitle: "Talk to a real person",
    contact: "Message us on WhatsApp",
  },
  founder: {
    eyebrow: "Our Story",
    title: "Real people behind every pair.",
    videoLabel: "Video · Introduction",
    videoAria: "Play introduction video",
    body: [
      "Kelo Diamonds was created with a straightforward idea: premium jewelry should feel exceptional, transparent and personal.",
      "We believe customers deserve to know exactly what they are buying. That is why every pair is presented with clear specifications, real product images, transparent sizing and direct support before and after the order.",
      "Our goal is not simply to sell jewelry. It is to create an experience where every customer feels confident before making a purchase.",
    ],
    signature: "— The Kelo Diamonds team",
  },
  reviews: {
    eyebrow: "Clients",
    title: "What people are saying about Kelo.",
    subtitle: "Verified reviews from real customers.",
    verified: "Verified purchase",
    ratingLabel: (r) => `${r} out of 5`,
  },
  lead: {
    eyebrowStep1: "Private list",
    eyebrowStep2: "Almost done",
    title: "Get $10 off your first order.",
    subtitle: "Receive your private discount and early access to new KELO DIAMONDS releases.",
    step1Question: "Where should we send your offer?",
    step2Question: "Almost done — tell us your name and the other contact.",
    firstNameLabel: "First name",
    firstNamePlaceholder: "Your name",
    emailLabel: "Email address",
    emailPlaceholder: "you@email.com",
    phoneLabel: "Phone number",
    phonePlaceholder: "+1 555 000 0000",
    ctaStep1: "Continue",
    ctaStep2: "Get my $10 off",
    stepIndicator: (n) => `Step ${n} of 2`,
    back: "Back",
    close: "Close",
    consent:
      "By submitting, you agree to receive occasional email and SMS updates from KELO DIAMONDS. Message and data rates may apply. Reply STOP to unsubscribe.",
    privacy: "Privacy policy",
    terms: "Terms",
    errorEmail: "Please enter a valid email address.",
    errorPhone: "Please enter a valid phone number.",
    errorName: "Please enter your first name.",
    errorContact: "Please enter an email or phone number.",
    errorGeneric: "We couldn’t save your details right now. Please try again in a moment.",
    successTitle: "You’re in.",
    successSubtitle: "Use this code on your first order:",
    successCode: "WELCOME10",
    successNote: "We also sent it to your email — check your inbox.",
    copy: "Copy code",
    copied: "Copied",
    shopCta: "Shop the collection",
    continueCta: "Continue browsing",
    footerCta: "Join the private list",
    footerNote: "$10 off your first order + early access.",
  },
  faq: {
    title: "Frequently Asked Questions",
    items: [
      ["What is moissanite?", "Moissanite is a premium gemstone (silicon carbide) known for its exceptional brilliance and durability. It is not a diamond."],
      ["What does CTW mean?", "CTW refers to the combined diamond-equivalent size of both earrings — for example, 2 CTW is approximately 1 CT diamond-equivalent per earring."],
      ["Are the earrings sold as a pair?", "Yes. Every order includes one complete matching pair."],
      ["What material are they made of?", "The settings are genuine 925 sterling silver with a four-prong setting."],
      ["Does moissanite lose its shine?", "With proper care, moissanite maintains its brilliance beautifully over time."],
      ["Can I wear them every day?", "Yes, with standard care they are well suited for frequent wear."],
      ["How do I clean them?", "Use mild soap, warm water and a soft cloth. Avoid harsh chemicals."],
      ["How do I choose my size?", "Use our size guide, or message us on WhatsApp for a personalized recommendation."],
      ["How does ordering work?", "Select your style, size and quantity, then complete your order through WhatsApp where our team confirms the details."],
      ["How long does shipping take?", "Delivery timing and options are confirmed with our team before payment."],
      ["Can I contact someone before ordering?", "Absolutely. Message us on WhatsApp any time before placing your order."],
    ],
  },
  finalCta: { title: "Find the Perfect Pair.", subtitle: "Refined everyday luxury, made to be worn with confidence.", primary: "Shop Classic Studs", whatsapp: "Order on WhatsApp" },
  footer: {
    statement: "Premium moissanite jewelry, presented with clarity and personalized service.",
    shop: "Shop",
    bestSellers: "Best Sellers",
    sizeGuide: "Size Guide",
    faq: "FAQ",
    shipping: "Shipping",
    privacy: "Privacy Policy",
    terms: "Terms",
    contact: "Contact",
    rights: "All rights reserved.",
  },
  cart: {
    title: "Your Cart",
    empty: "Your cart is empty.",
    emptyHint: "A masterpiece awaits.",
    item: "item",
    items: "items",
    moreItem: "more item",
    moreItems: "more items",
    view: "View cart",
    size: "Size",
    qty: "Qty",
    subtotal: "Subtotal",
    total: "Total",
    checkout: "Complete Order on WhatsApp",
    remove: "Remove",
    clear: "Clear cart",
    shippingNote: "Shipping and final delivery details will be confirmed with our team.",
  },
  whatsapp: {
    order: (lines, total) =>
      `Hello, Kelo Diamonds.\n\nI would like to place an order with the following details:\n\n${lines}\n\nOrder total: ${total} USD\n\nPlease confirm availability, payment options and delivery information.`,
    line: ({ name, size, qty, unit }) =>
      `Product: ${name}\nSize: ${size}\nQuantity: ${qty}\nUnit price: ${unit} USD`,
    consult: "Hello, Kelo Diamonds. I'd like help choosing the right size for the Moissanite Studs. Could you assist me?",
    support: "Hello, Kelo Diamonds. I have a question before placing my order.",
    hint: "Need help choosing?",
  },
  products: {
    classic: { name: "Classic Moissanite Studs", short: "The timeless round-cut classic." },
    halo: { name: "Halo Moissanite Studs", short: "A halo of brilliance around the stone." },
    princess: { name: "Princess Cut Moissanite Studs", short: "Sharp, modern princess-cut lines." },
  },
  product: {
    breadcrumbHome: "Home",
    back: "Back",
    backHome: "Back to shop",
    notFound: "Product not found",
    related: "You may also like",
    includes: "What's included",
    stone: "Stone",
    cut: "Cut",
    metal: "Metal",
    backing: "Backing",
    adding: "Adding…",
    selectSizeFirst: "Please select a size before adding.",
    addError: "Unable to add this item. Please try again.",
    soldOut: "Sold Out",
    specs: {
      classic: { stone: "VVS Moissanite", cut: "Round Brilliant", metal: "925 Sterling Silver", backing: "Screw-back" },
      halo:    { stone: "VVS Moissanite", cut: "Round + Pavé Halo", metal: "925 Sterling Silver", backing: "Screw-back" },
      princess:{ stone: "VVS Moissanite", cut: "Princess", metal: "925 Sterling Silver", backing: "Screw-back" },
      default: { stone: "VVS Moissanite", cut: "Round Brilliant", metal: "925 Sterling Silver", backing: "Screw-back" },
    },
  },
  lang: { en: "English", es: "Español" },
};

export default en;
